import PublicActivity from '@/pages/publicPages/PublicActivity/PublicActivity';
import PublicActivitySSP from '@/pages/publicPages/PublicActivity/PublicActivity.ssp';

export default function StoryWithQuestionsActivity(props) {
  return <PublicActivity {...props.pageProps} />;
}

export const getServerSideProps = async (context) =>
  await PublicActivitySSP({
    context,
    activityTypeSlug: 'stories-with-questions',
  });
